import CONFIG from "config/env";
import React from "react";
import {useDispatch, useSelector} from "react-redux";
import axiosInstance from "services/axios";
import {setAuthenticatedUser} from "store/actions/auth";
import {setSelectedHospital} from "store/actions/hospital";

export function LoginPage() {
	const SUPPORTED_ROLE_IDS = [1, 2, 3, 4, 5, 6, 7, 8];
	const userProfile = useSelector(state => state.AuthReducer.profile);
	const dispatch = useDispatch();

	React.useEffect(() => {
		if (userProfile) return;

		let cancelled = false;
		const controller = new AbortController();

		(async () => {
			try {
				const res = await axiosInstance.get(`${CONFIG.endpoint.API_ENDPOINT}/auth/me`, {
					signal: controller.signal,
				});

				if (!res.data?.success) return; // no-op when unauthorized or error

				const body = res.data;

				if (!cancelled && body?.data) {
					const basicProfile = body.data;
					const rsMany = Array.isArray(basicProfile?.staff?.rsMany) ? basicProfile.staff.rsMany : [];
					const getAllRolesId = rsMany.map(item => item?.roleId).filter(Boolean);
					const selectedRoleId =
						getAllRolesId.find(roleId => SUPPORTED_ROLE_IDS.includes(Number(roleId))) || 0;
					const selectedHospital =
						rsMany.find(item => Number(item?.roleId) === Number(selectedRoleId)) || null;

					dispatch(
						setAuthenticatedUser({
							accessToken: "",
							accessExpired: null,
							isPersisted: true,
							profile: basicProfile,
							isLoggedIn: true,
							userRoles: [...new Set(getAllRolesId)],
							roleId: selectedRoleId,
						}),
					);
					dispatch(setSelectedHospital(selectedHospital));
					// window.location = "/";
				}
			} catch (_) {
				// no-op on failure
				window.location = `${CONFIG.sso.SSO_ENDPOINT}`; //?redirect_uri=${CONFIG.sso.SSO_REDIRECT_URI}&client_id=${CONFIG.sso.SSO_CLIENT_ID}`;
			}
		})();

		return () => {
			cancelled = true;
			controller.abort();
		};
	}, []);

	return <div>Loading...</div>;
}
